import React from 'react';
import * as css from './spinner.module.scss';

const Spinner: React.FC<React.PropsWithChildren<{ height?: string }>> = ({
  height,
}) => (
  <div className={css.centerDiv} style={height ? { height } : undefined}>
    <div className={css.loader}>Loader</div>
  </div>
);

export default Spinner;
